import { CurrencyEnum } from '../../types/enums';

type BurnRate = {
  amount: number;
  currency: CurrencyEnum;
};

type BurnRateState = BurnRate | null;

interface BurnRateAction {
  type: string;
  amount: number;
  currency: CurrencyEnum;
}

export default (state: BurnRateState = null, action: BurnRateAction) => {
  switch (action.type) {
    case 'BURN_RATE':
      return { amount: action.amount, currency: action.currency };
    default:
      return state;
  }
};
